import type { ReactNode } from 'react';

import { Label } from './label';

interface FormFieldProps {
  label: string;
  htmlFor: string;
  error?: string | undefined;
  helper?: string;
  children: ReactNode;
}

// Helper para agrupar label + input + error + helper de forma consistente.
// Reduce boilerplate en cada form sin esconder Radix Label.
export function FormField({ label, htmlFor, error, helper, children }: FormFieldProps): JSX.Element {
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
      {error && (
        <span role="alert" className="text-xs text-danger">
          {error}
        </span>
      )}
      {!error && helper && <span className="text-xs text-marca-gris/60">{helper}</span>}
    </div>
  );
}
